// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"9cc491b8","276":"d8776d66","277":"bd454e0d","362":"2ebf255a","386":"faa46664","409":"245be947","453":"926f0775","736":"c44a53c5","987":"f9f41d31"}[chunkId] + ".chunk.js";
};